<template>
    <Modal v-if="showModal" title="State Transition Actions" no-max-width @close="close">
        <div class="order-transition-actions">
            <Spinner v-if="loading" />
            <SimpleFlexTable
                :data="actions"
                :head="[
                    { text: 'Action Name', width: 35 },
                    { text: 'Start', width: 20 },
                    { text: 'End', width: 20 },
                    { text: 'State', width: 15 },
                    { text: 'Restart', width: 10 },
                ]"
            >
                <template #default="{ item: action }">
                    <div>{{ action.action_func_name }}</div>
                    <div>{{ formatLocaleTimestamp(action.start, $i18n.locale) }}</div>
                    <div>{{ formatLocaleTimestamp(action.end, $i18n.locale) }}</div>
                    <div>{{ action.state.label }}</div>
                    <div>
                        <button
                            v-if="action.restart_action && !actionRestarted(action)"
                            type="button"
                            class="button button--blank"
                            @click="restartAction(action)"
                        >
                            Restart
                        </button>
                        <span v-if="action.restart_action && actionRestarted(action)">
                            Restarted
                        </span>
                    </div>
                </template>
                <template #empty>
                    <div>No Actions</div>
                </template>
            </SimpleFlexTable>
        </div>
    </Modal>
</template>

<script>
import { Modal } from '@speechki-frontend/shared/ui/modals';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import SimpleFlexTable from '@speechki-frontend/shared/ui/SimpleFlexTable/SimpleFlexTable';

import { fetchOrderTransitionActionState, restartOrderTransitionAction } from '../../api/orders';

import { formatLocaleTimestamp } from '@speechki-frontend/shared/helpers/functions';

export default {
    name: 'OrderTransitionActions',
    components: {
        Modal,
        SimpleFlexTable,
        Spinner,
    },

    data() {
        return {
            showModal: false,
            actions: [],
            restartedActions: [],
            transition: undefined,
            loading: false,
        };
    },

    methods: {
        formatLocaleTimestamp,
        async open(transition) {
            this.showModal = true;
            this.loading = true;
            this.transition = transition;
            await this.fetchActions();
            this.loading = false;
        },
        close() {
            this.actions = [];
            this.restartedActions = [];
            this.showModal = false;
            this.transition = null;
        },
        async fetchActions() {
            this.actions = await fetchOrderTransitionActionState(
                this.transition.id,
                this.$route.params.id
            );
        },
        async restartAction(action) {
            this.loading = true;

            try {
                await restartOrderTransitionAction(this.transition.object_id, action.id);
                this.restartedActions.push(action.id);
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        actionRestarted(action) {
            return this.restartedActions.includes(action.id);
        },
    },
};
</script>

<style lang="scss" src="./OrderTransitionActions.scss"></style>
